/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'info-box',
};
